<!--
  use component is syntax to avoid inline block space issues
  @see https://css-tricks.com/fighting-the-space-between-inline-block-elements/
-->
<template>
  <div id="keycodes-section">
    <!--div style="text-align: left; margin-left: 10px;">
      <p>
        <label>{{ $t('keycodes.label') }}:</label>
        <span class="hint">
          <a
            href="https://docs.qmk.fm/#/keycodes"
            title="Keycodes reference"
            target="_blank"
            >{{ $t('keycodesRef.label') }}</a
          >
        </span>
      </p>
    </div-->
    <div id="keycodes">
      <div class="tabs">
        <span
          class="tab"
          :class="classes(index)"
          v-for="(key, index) in keycodesByGroup"
          :key="index"
          @click="changeActive(index)"
          :title="$t('keycodesTab.' + index + '.label')"
          >{{ $t('keycodesTab.' + index + '.label')
          }}<span v-if="searchFilter !== ''"
            >({{ searchCounters[index] }})</span
          ></span
        >
        <span class="end-tab"
          ><font-awesome-icon class="keycode-search-icon" icon="search"/><input
            @focus="stopListening"
            @blur="startListening"
            type="text"
            :placeholder="$t('searchKeycodes')"
            v-model="searchFilter_"
            autocomplete="off"
            spellcheck="false"
        /></span>
      </div>
      <div class="tab-area macro-tab-area">
        <template v-for="(key, index) in activeTab">
          <component
            v-bind:is="getComponent(key.code)"
            v-bind="key"
            :key="index"
            :class="filterClass(key)"
            @mouseenter="message(key)"
          />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import isUndefined from 'lodash/isUndefined';
import debounce from 'lodash/debounce';
import Keycode from '@/components/Keycode';
import Space from '@/components/Space';
import store from '@/store';

export default {
  name: 'macro-keycodes',
  components: { Keycode, Space },
  props: {},
  data() {
    const userLang = navigator.language || navigator.userLanguage;
    let active = 'MacroBase';
    // if (userLang.toLowerCase().indexOf('en') < 0) {
    //   active = 'ISO/JIS';
    // }
    return {
      active: active,
      clearTimeout: undefined
    };
  },
  mounted() {
    this.debouncedSetSearchFilter = debounce(this.setSearchFilter, 500);
  },
  computed: {
    ...mapGetters('keycodes', ['macroKeycodes']),
    ...mapState('keycodes', ['searchFilter', 'searchCounters']),
    activeTab() {
      return this.keycodesByGroup[this.active];
    },
    keycodesByGroup() {
      let section = this.macroKeycodes.reduce((acc, value) => {
        if (value.group) {
          acc[value.label] = [];
          acc.current = value.label;
        } else {
          acc[acc.current].push(value);
        }
        return acc;
      }, {});
      delete section['current'];
      return section;
    },
    searchFilter_: {
      get() {
        return this.searchFilter;
      },
      set(newVal) {
        this.debouncedSetSearchFilter(newVal);
      }
    }
  },
  methods: {
    ...mapMutations('app', ['setMessage', 'stopListening', 'startListening']),
    ...mapMutations('keycodes', ['setSearchFilter']),
    getComponent(code) {
      return isUndefined(code) ? Space : Keycode;
    },
    classes(current) {
      let classes = [];
      if (current === this.active) {
        classes.push('active');
      }
      return classes.join(' ');
    },
    changeActive(index) {
      this.active = index;
    },
    message(key) {
      let msg = '';
      if (isUndefined(key.code)) {
        msg = key.title ? key.title : '';
      } else {
        msg = key.title ? `${key.title}` : key.code;
      }
      this.setMessage(msg);
      this.messageClear();
    },
    messageClear() {
      if (this.clearTimeout) {
        window.clearTimeout(this.clearTimeout);
      }
      this.clearTimeout = window.setTimeout(() => {
        store.commit('app/setMessage', '');
      }, 3000);
    },
    filterClass(key) {
      if (this.searchFilter === '' || isUndefined(key.code)) {
        return '';
      }
      const filter = this.searchFilter_.toUpperCase();
      if (
        !key.code.includes(filter) &&
        !(key.name && key.name.toUpperCase().includes(filter)) &&
        !(key.title && key.title.toUpperCase().includes(filter))
      ) {
        return 'desaturated';
      }
    }
  }
};
</script>
<style>
.macro-tab-area {
  height: 240px;
}
</style>
